import React from 'react';
import { Link, useRecordContext } from 'react-admin';
import { queuesFields } from "../../queues.model";
import { PROVIDER_RESOURCE_NAME } from "../../../users/provider.dataProvider";
import EmptyField from "@/material/emptyField.component";

const ProviderLinkField = ({ source, addLabel = true }) => {
    const record = useRecordContext();

    if (!record || !source) {
        return null;
    }

    const value = record[source];
    if (!value) {
        return <EmptyField />;
    }

    const label = `${record[queuesFields.providerFirstName]} ${record[queuesFields.providerLastName]}`
    return (
        <Link to={`/${PROVIDER_RESOURCE_NAME}/${value}/show`}>
            {label}
        </Link>
    );
};

export default ProviderLinkField;
